import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import EnExportIcon from 'Components/icons/EnExportIcon.vue';
import EnTooltip from 'Components/base/EnTooltip/EnTooltip.vue';
import { EnButton } from 'Components/base/EnButton';
import { dateFormat } from 'Js/utils/dateFormat';
import { EnItem } from 'Components/base/EnItem';
import { Notification } from 'Js/signalR/notification';
import { useNotificationType } from '../composables/useNotificationType';
import { X } from 'lucide-vue-next';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnNotificationListItem',
    props: {
        /**
         * Message to be shown
         */
        item: Notification,
        /**
         * If true, x (close) button appears in the top-right corner
         */
        canBeRead: {
            type: Boolean,
            default: true
        }
    },
    emits: ['on:notification:read'],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const { t } = useI18n();
        const props = __props;
        const emit = __emit;
        const formattedTime = computed(() => dateFormat(props.item?.localDate));
        // Compute the appropriate icon based on the notification type
        const { notificationType, icon } = useNotificationType(props.item?.type);
        function handleOnNotificationRead() {
            emit('on:notification:read', props.item);
        }
        const __returned__ = { t, props, emit, formattedTime, notificationType, icon, handleOnNotificationRead, EnExportIcon, EnTooltip, get EnButton() { return EnButton; }, get EnItem() { return EnItem; }, get X() { return X; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
